"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _deviceUtils = require("./deviceUtils");
Object.keys(_deviceUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _deviceUtils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _deviceUtils[key];
    }
  });
});
var _errorReplacer = require("./errorReplacer");
Object.keys(_errorReplacer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _errorReplacer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _errorReplacer[key];
    }
  });
});
var _getNameInitials = require("./getNameInitials");
Object.keys(_getNameInitials).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getNameInitials[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getNameInitials[key];
    }
  });
});
var _getURLPathParams = require("./getURLPathParams");
Object.keys(_getURLPathParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getURLPathParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getURLPathParams[key];
    }
  });
});